module.exports = __webpack_public_path__ + "static/media/App.806e6cd9.rs";